import { useCallback, useEffect, useState } from 'react';


const useQuery = (getter, args={}) => {
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState();
  const [error, setError] = useState();

  const sortedArgValues = Object.keys(args).sort().map((key) => [key, args[key]]);
  const sortedArgs = Object.fromEntries(sortedArgValues);
  const sortedArgsString = new URLSearchParams(sortedArgs).toString()

  const fetchData = useCallback(async () => {
    setLoading(true);
    const response = await getter(sortedArgs);
    if (response.status === 200) {
      setResponse(response);
    } else {
      setError(response);
    }
    setLoading(false);
    // eslint-disable-next-line
  }, [getter, sortedArgsString])

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { loading, response, error, refetch: fetchData }
}

export default useQuery;
